import { Header, Loader } from "./components";
import { DroppableWorkflow as WorkflowColumn } from "./WorkflowColumn";

WorkflowColumn.Loader = Loader;
WorkflowColumn.Header = Header;

export default WorkflowColumn;
